"use client";
import { jsx as s } from "react/jsx-runtime";
import * as a from "@radix-ui/react-tabs";
import { cva as l } from "class-variance-authority";
import { createContext as c, useContext as d } from "react";
import { cn as r } from "./index.es22.js";
const n = c({}), u = l(
  `data-[state=active]:bg-gray-800 data-[state=active]:text-white
    inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-3 border border-transparent px-4 py-3 text-base border-none whitespace-nowrap
    focus-visible:border-ring focus-visible:ring-ring/50
    focus-visible:outline-2 focus-visible:outline-blue-600 focus-visible:outline-offset-2
    disabled:pointer-events-none disabled:opacity-50 hover:cursor-pointer
    [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4`,
  {
    variants: {
      shape: {
        square: "rounded-sm data-[state=active]:rounded-sm",
        rounded: "rounded-md data-[state=active]:rounded-capsule"
      },
      outline: {
        true: "data-[state=active]:border data-[state=active]:border-solid data-[state=active]:border-gray-500",
        false: ""
      }
    },
    defaultVariants: {
      shape: "rounded",
      outline: !1
    }
  }
), m = ({ className: e, shape: t, outline: o, ...i }) => /* @__PURE__ */ s(n.Provider, { value: { shape: t, outline: o }, children: /* @__PURE__ */ s(a.Root, { "data-slot": "tabs", className: r("flex flex-col gap-2", e), ...i }) }), g = ({ className: e, ...t }) => /* @__PURE__ */ s(
  a.List,
  {
    "data-slot": "tabs-list",
    className: r("inline-flex h-13 w-fit items-center justify-center", e),
    ...t
  }
), x = ({ className: e, ...t }) => {
  const { shape: o, outline: i } = d(n);
  return /* @__PURE__ */ s(
    a.Trigger,
    {
      "data-slot": "tabs-trigger",
      className: r(u({ shape: o, outline: i }), e),
      ...t
    }
  );
}, h = ({ className: e, ...t }) => /* @__PURE__ */ s(a.Content, { "data-slot": "tabs-content", className: r("flex-1 outline-none", e), ...t });
export {
  h as TabsContent,
  g as TabsList,
  m as TabsRoot,
  x as TabsTrigger
};
